// Outils de la revue d'avancement (GET /progress-review, /progress-review/projects/{id}).

const DAY = new Intl.DateTimeFormat('fr-FR', { weekday: 'long', day: 'numeric', month: 'long' });
const SHORT = new Intl.DateTimeFormat('fr-FR', { day: 'numeric', month: 'short' });

const noon = (iso) => new Date(`${String(iso).slice(0, 10)}T12:00:00`);

export const shortDate = (iso) => (iso ? SHORT.format(noon(iso)) : '—');
export const longDate = (iso) => (iso ? DAY.format(noon(iso)) : '—');

/** « aujourd'hui », « hier », « il y a 9 jours » pour un horodatage UTC du serveur. */
export const ago = (stamp, now = new Date()) => {
  if (!stamp) return null;
  const then = new Date(String(stamp).replace(' ', 'T'));
  const days = Math.floor((new Date(now.getFullYear(), now.getMonth(), now.getDate()) -
    new Date(then.getFullYear(), then.getMonth(), then.getDate())) / 86400000);
  if (days <= 0) return "aujourd'hui";
  if (days === 1) return 'hier';
  return `il y a ${days} jours`;
};

/** Valeur saisie → nombre entre 0 et 100, ou null. */
export const parsePercent = (text) => {
  if (text === '' || text == null) return null;
  const value = Number(String(text).replace(',', '.').replace('%', '').trim());
  return Number.isFinite(value) && value >= 0 && value <= 100 ? Math.round(value * 10) / 10 : null;
};

/**
 * Ce qu'on envoie pour un projet : pour chaque itération, le nouveau % ou rien (« inchangé »).
 * { ready, changed, entries } : ready = chaque itération a un % (déjà noté ou saisi).
 */
export const notesFor = (iterations, drafts) => {
  let ready = true;
  let changed = false;
  const entries = iterations.map((it) => {
    const draft = drafts[it.id] || {};
    const last = it.progress?.percent ?? null;
    const value = parsePercent(draft.value ?? (last == null ? '' : String(last)));
    if (value == null) ready = false;
    const differs = value != null && (last == null || Math.abs(value - last) >= 0.05);
    if (differs) changed = true;
    return { iteration_id: it.id, percent: differs ? value : null, comment: (draft.comment || '').trim() || null };
  });
  return { ready: ready && iterations.length > 0, changed, entries };
};

/** File de la revue : les projets à revoir d'abord ; s'il n'y en a aucun, tous. */
export const queueOf = (projects) => {
  const due = projects.filter((p) => p.due);
  return (due.length ? due : projects).map((p) => p.id);
};
